/**
 * RULE 9 — "Prioritise latest deal" (server `followup-rules.ts`). The deal
 * detail (`GET /child/:id`) ships `followUpMuted` when a live sibling deal
 * further along sits in a prioritised bucket: this deal's follow-ups are
 * muted on every follow-up surface, so the drawer says so instead of
 * showing a pending row nobody will be chased for.
 */
export interface DealFollowUpMute {
  byChildId: number;
  byChildName: string | null;
  stageName: string | null;
  statusName: string | null;
}

/** The `followUpMuted` field off a deal record, if present and well-formed. */
export function readDealFollowUpMute(entity: unknown): DealFollowUpMute | null {
  const raw = (entity as { followUpMuted?: unknown } | null | undefined)
    ?.followUpMuted;
  if (!raw || typeof raw !== "object") return null;
  const m = raw as Partial<DealFollowUpMute>;
  if (!Number.isFinite(Number(m.byChildId))) return null;
  return {
    byChildId: Number(m.byChildId),
    byChildName: m.byChildName ?? null,
    stageName: m.stageName ?? null,
    statusName: m.statusName ?? null,
  };
}

/** "the lead's newest deal, Oxford (Visa · Visa Approved)" */
export function describeMutingDeal(m: DealFollowUpMute): string {
  const where = [m.stageName, m.statusName].filter(Boolean).join(" · ");
  const name = m.byChildName?.trim();
  if (name && where) return `${name} (${where})`;
  if (name) return name;
  if (where) return `a newer deal in ${where}`;
  return "a newer deal";
}
